<template>
    <section>
        <div class="page">
            <div>
                <h2>To reply to a message</h2>
                <p>Long press the message and click <strong>Reply</strong> on the prompted
                    menu.
                </p>


            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
